import { render } from "./CompetenceTaskModalForm.vue?vue&type=template&id=53019e1d"
import script from "./CompetenceTaskModalForm.vue?vue&type=script&lang=js"
export * from "./CompetenceTaskModalForm.vue?vue&type=script&lang=js"

import "./CompetenceTaskModalForm.vue?vue&type=style&index=0&id=53019e1d&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__